import React, { useState, useEffect, useRef } from "react"
import { connect } from "react-redux"
import {
  Table,
  Input,
  Space,
  Button,
  Row,
  Col,
  Form,
  InputNumber,
  Radio,
  Modal,
  Card,
  Typography,
  Tooltip,
  Switch,
} from "antd"
import {
  UserOutlined,
  IdcardOutlined,
  PhoneOutlined,
  BankOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
  PlusOutlined,
  EditOutlined,
  ReloadOutlined,
  SaveOutlined,
  CloseOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SafetyCertificateOutlined,
  NumberOutlined,
  DownloadOutlined,
} from "@ant-design/icons"
import * as XLSX from "xlsx"
import { columns } from "./columns"
import { PersianDatePickerInline } from "components/Common/PersianDatePickerInline"
import {
  addUserFile,
  deleteUserFile,
  filterEngineer,
  filterLoading,
  getListEngineer,
  getUserFiles,
  resetUSERFlag,
  upsertEngHistory,
  upsertEngineer,
} from "store/actions"
import Locations from "components/Common/Locations"
import { withTranslation } from "react-i18next"
import { GetCityWithSection } from "hooks/returnCityName"

const { Title, Text } = Typography

const EngineerList = props => {
  const {
    lstEngineer,
    loading,
    onGetListEngineer,
    onUpsertEngineer,
    onFilterEngineer,
    openNotification,
    onFilterLoading,
  } = props
  const [form] = Form.useForm()

  const [editingId, setEditingId] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)

  const [solarBirthDate, setSolarBirthDate] = useState("")
  const [solarMembershipDate, setSolarMembershipDate] = useState("")
  const [solarInsuranceExpirationDate, setSolarInsuranceExpirationDate] = useState("")
  const [fullName, setFullName] = useState("")
  const [filterAddress, setFilterAddress] = useState(0)

  const filterTimeout = useRef(null)

  const [dataAddress, setDataAddress] = useState({
    sectionId: 0,
    fullAddress: {
      pro: "",
      cit: "",
      sec: "",
      lat: 35.311308,
      lng: 46.991271,
      mainAddress: "",
    },
  })

  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra)
  }

  useEffect(() => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
  }, [props.success, props.error])

  useEffect(() => {
    onGetListEngineer()
  }, [])

  // Debounced filter for fullName
  const handleFullNameFilter = e => {
    const value = e.target.value
    setFullName(value)
    if (filterTimeout.current) clearTimeout(filterTimeout.current)
    onFilterLoading(true)
    filterTimeout.current = setTimeout(() => {
      onFilterEngineer({
        fullName: value,
        idSection: dataAddress.sectionId,
        filterAddress,
      })
    }, 400)
  }

  // Fetch data or set initial values if needed
  useEffect(() => {
    if (!editingId) {
      onFilterLoading(true)
      const timeout = setTimeout(() => {
        onFilterEngineer({
          fullName,
          idSection: dataAddress.sectionId,
          filterAddress,
        })
      }, 1000)
      return () => clearTimeout(timeout)
    }
  }, [dataAddress, filterAddress])

  // Function to handle form submission
  const handleSubmit = values => {
    setModalLoading(true)
    let updatedData = {
      ...values,
      solarBirthDate: solarBirthDate.persian,
      solarMembershipDate: solarMembershipDate.persian,
      solarInsuranceExpirationDate: solarInsuranceExpirationDate.persian,
      idSection: +dataAddress.sectionId,
      id: editingId,
    }
    delete updatedData.julianBirthDate
    delete updatedData.julianMembershipDate
    onUpsertEngineer(updatedData)

    setTimeout(() => {
      setModalLoading(false)
      handleCloseModal()
    }, 500)
  }

  // Function to handle edit button click
  const handleEdit = record => {
    form.setFieldsValue(record)
    setEditingId(record.id)
    setIsModalOpen(true)
  }

  // Open modal for creating new engineer
  const handleOpenCreateModal = () => {
    form.resetFields()
    setEditingId(null)
    setSolarBirthDate("")
    setSolarMembershipDate("")
    setSolarInsuranceExpirationDate("")
    setDataAddress({
      sectionId: 0,
      fullAddress: {
        pro: "",
        cit: "",
        sec: "",
        lat: 35.311308,
        lng: 46.991271,
        mainAddress: "",
      },
    })
    setIsModalOpen(true)
  }

  // Close modal
  const handleCloseModal = () => {
    setIsModalOpen(false)
    setEditingId(null)
    form.resetFields()
  }

  // Export to Excel
  const handleExportToExcel = () => {
    const exportData = lstEngineer.map(x => ({
      "نام کامل": x.fullName || "",
      "کدملی": x.naCode || "",
      "موبایل": x.cellPhone || "",
      "پایه": x.engineerGradeTypeName || "",
      "ضریب": x.factor || "",
      "شماره حساب": x.bankAccountNumber || "",
      "شهر": GetCityWithSection(x.idSection) || "",
      "تاریخ عضویت": x.solarMembershipDate || "",
    }))
    const worksheet = XLSX.utils.json_to_sheet(exportData)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "مهندسین")
    XLSX.writeFile(workbook, "لیست مهندسین.xlsx")
  }

  return (
    <>
      {/* Header Section */}
      <div style={{ 
        background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
        padding: '20px',
        borderRadius: '12px',
        marginBottom: '16px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
      }}>
        <Row justify="space-between" align="middle">
          <Col>
            <h2 style={{ color: 'white', margin: 0, fontSize: '24px', fontWeight: '600' }}>
              👨‍💼 مدیریت مهندسین
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', margin: '4px 0 0 0', fontSize: '14px' }}>
              ایجاد، ویرایش و مدیریت اطلاعات مهندسین
            </p>
          </Col>
          <Col>
            <Space>
              <Button 
                type="primary" 
                size="large"
                icon={<PlusOutlined />}
                onClick={handleOpenCreateModal}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  border: '1px solid rgba(255,255,255,0.3)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '8px',
                  color: 'white',
                  fontWeight: '500'
                }}
              >
                افزودن مهندس
              </Button>
              <Button 
                size="large"
                icon={<DownloadOutlined />}
                onClick={handleExportToExcel}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  border: '1px solid rgba(255,255,255,0.3)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '8px',
                  color: 'white',
                  fontWeight: '500'
                }}
              >
                خروجی اکسل
              </Button>
            </Space>
          </Col>
        </Row>
      </div>

      {/* Filter Section */}
      <Card 
        style={{ 
          marginBottom: '16px', 
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
        }}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={8} md={6}>
            <Input
              prefix={<UserOutlined style={{ color: '#bfbfbf' }} />}
              placeholder="جستجو بر اساس نام..."
              value={fullName}
              onChange={handleFullNameFilter}
              size="large"
              style={{ borderRadius: '8px' }}
              allowClear
            />
          </Col>
          <Col xs={24} sm={10} md={8}>
            <Locations
              setDataAddress={setDataAddress}
              matches_sm={true}
              idSection={form.getFieldValue("idSection")}
            />
          </Col>
          <Col xs={24} sm={6} md={6}>
            <Radio.Group
              onChange={e => setFilterAddress(e.target.value)}
              value={filterAddress}
              buttonStyle="solid"
            >
              <Radio.Button value={0}>استان</Radio.Button>
              <Radio.Button value={1}>شهرستان</Radio.Button>
              <Radio.Button value={2}>بخش</Radio.Button>
            </Radio.Group>
          </Col>
          <Col>
            <Button
              icon={<ReloadOutlined />}
              onClick={() => {
                setFullName("")
                setFilterAddress(0)
                onGetListEngineer()
              }}
              style={{ borderRadius: '8px' }}
            >
              ریست فیلتر
            </Button>
          </Col>
        </Row>
      </Card>

      {/* Create/Edit Modal */}
      <Modal
        title={
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px',
            borderBottom: '1px solid #f0f0f0',
            paddingBottom: '16px',
            marginBottom: '8px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              background: editingId 
                ? 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)'
                : 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}>
              {editingId ? (
                <EditOutlined style={{ fontSize: '24px', color: 'white' }} />
              ) : (
                <PlusOutlined style={{ fontSize: '24px', color: 'white' }} />
              )}
            </div>
            <div>
              <Title level={4} style={{ margin: 0, color: '#1f2937' }}>
                {editingId ? 'ویرایش مهندس' : 'افزودن مهندس جدید'}
              </Title>
              <Text type="secondary" style={{ fontSize: '13px' }}>
                {editingId ? 'اطلاعات مهندس را ویرایش کنید' : 'اطلاعات مهندس جدید را وارد کنید'}
              </Text>
            </div>
          </div>
        }
        open={isModalOpen}
        onCancel={handleCloseModal}
        width={900}
        centered
        destroyOnClose
        footer={null}
        style={{ top: 20 }}
        styles={{
          body: { 
            maxHeight: 'calc(100vh - 200px)', 
            overflowY: 'auto',
            padding: '0 24px 24px'
          }
        }}
      >
        <Form 
          form={form} 
          layout="vertical" 
          onFinish={handleSubmit}
          requiredMark="optional"
        >
          {/* Personal Information Section */}
          <Card
            type="inner"
            title={
              <Space>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '8px',
                  background: 'linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <UserOutlined style={{ color: '#1890ff', fontSize: '16px' }} />
                </div>
                <Text strong style={{ fontSize: '15px' }}>اطلاعات شخصی</Text>
              </Space>
            }
            style={{ marginBottom: '16px', borderRadius: '12px', border: '1px solid #e8e8e8' }}
            headStyle={{ background: '#fafafa', borderRadius: '12px 12px 0 0' }}
          >
            <Row gutter={[16, 8]}>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="نام و نام خانوادگی"
                  name="fullName"
                  rules={[{ required: true, message: "نام را وارد کنید" }]}
                >
                  <Input
                    prefix={<UserOutlined style={{ color: '#bfbfbf' }} />}
                    placeholder="نام کامل"
                    size="large"
                    style={{ borderRadius: '8px' }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="کد ملی"
                  name="naCode"
                  rules={[{ required: true, message: "کد ملی را وارد کنید" }]}
                >
                  <InputNumber
                    prefix={<IdcardOutlined style={{ color: '#bfbfbf' }} />}
                    placeholder="کد ملی 10 رقمی"
                    style={{ width: '100%', borderRadius: '8px' }}
                    size="large"
                    controls={false}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="موبایل"
                  name="cellPhone"
                  rules={[{ required: true, message: "شماره موبایل را وارد کنید" }]}
                >
                  <Input
                    prefix={<PhoneOutlined style={{ color: '#bfbfbf' }} />}
                    placeholder="09XXXXXXXXX"
                    maxLength={11}
                    size="large"
                    style={{ borderRadius: '8px' }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          {/* Bank Information Section */}
          <Card
            type="inner"
            title={
              <Space>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '8px',
                  background: 'linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <BankOutlined style={{ color: '#52c41a', fontSize: '16px' }} />
                </div>
                <Text strong style={{ fontSize: '15px' }}>اطلاعات بانکی و مالی</Text>
              </Space>
            }
            style={{ marginBottom: '16px', borderRadius: '12px', border: '1px solid #e8e8e8' }}
            headStyle={{ background: '#fafafa', borderRadius: '12px 12px 0 0' }}
          >
            <Row gutter={[16, 8]}>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="شماره حساب"
                  name="bankAccountNumber"
                  rules={[{ required: true, message: "شماره حساب را وارد کنید" }]}
                >
                  <Input
                    prefix={<BankOutlined style={{ color: '#bfbfbf' }} />}
                    placeholder="شماره حساب بانکی"
                    size="large"
                    style={{ borderRadius: '8px' }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item label="اعتبار اولیه" name="defaultQuota">
                  <InputNumber
                    style={{ width: "100%", borderRadius: '8px' }}
                    size="large"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={value => value.replace(/,/g, '')}
                    placeholder="مبلغ به ریال"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  label="مسدودی حساب"
                  name="bankAccountBlocked"
                  valuePropName="checked"
                >
                  <Switch 
                    checkedChildren={<CheckCircleOutlined />}
                    unCheckedChildren={<CloseCircleOutlined />}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item label="ترتیب بندی" name="sortIndex">
                  <InputNumber 
                    style={{ width: '100%', borderRadius: '8px' }} 
                    size="large"
                    placeholder="شماره ترتیب"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          {/* Status Section */}
          <Card
            type="inner"
            title={
              <Space>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '8px',
                  background: 'linear-gradient(135deg, #fff1f0 0%, #ffa39e 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <SafetyCertificateOutlined style={{ color: '#ff4d4f', fontSize: '16px' }} />
                </div>
                <Text strong style={{ fontSize: '15px' }}>وضعیت فعالیت</Text>
              </Space>
            }
            style={{ marginBottom: '16px', borderRadius: '12px', border: '1px solid #e8e8e8' }}
            headStyle={{ background: '#fafafa', borderRadius: '12px 12px 0 0' }}
          >
            <Row gutter={[16, 8]}>
              <Col xs={24} sm={8}>
                <Form.Item
                  label="غیر فعال"
                  name="inactive"
                  valuePropName="checked"
                >
                  <Switch 
                    checkedChildren="غیرفعال"
                    unCheckedChildren="فعال"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={16}>
                <Form.Item label="دلیل غیر فعال" name="inactiveDes">
                  <Input.TextArea 
                    rows={2} 
                    placeholder="توضیحات..."
                    style={{ borderRadius: '8px' }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          {/* Location Information Section */}
          <Card
            type="inner"
            title={
              <Space>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '8px',
                  background: 'linear-gradient(135deg, #fffbe6 0%, #ffe58f 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <EnvironmentOutlined style={{ color: '#faad14', fontSize: '16px' }} />
                </div>
                <Text strong style={{ fontSize: '15px' }}>اطلاعات مکانی</Text>
              </Space>
            }
            style={{ marginBottom: '16px', borderRadius: '12px', border: '1px solid #e8e8e8' }}
            headStyle={{ background: '#fafafa', borderRadius: '12px 12px 0 0' }}
          >
            <Row gutter={[16, 8]}>
              <Col xs={24}>
                <Form.Item label="استان و شهر" name="idSection">
                  <Locations
                    setDataAddress={setDataAddress}
                    matches_sm={true}
                    idSection={form.getFieldValue("idSection")}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          {/* Date Information Section */}
          <Card
            type="inner"
            title={
              <Space>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '8px',
                  background: 'linear-gradient(135deg, #f9f0ff 0%, #d3adf7 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <CalendarOutlined style={{ color: '#722ed1', fontSize: '16px' }} />
                </div>
                <Text strong style={{ fontSize: '15px' }}>تاریخ‌های مهم</Text>
              </Space>
            }
            style={{ marginBottom: '24px', borderRadius: '12px', border: '1px solid #e8e8e8' }}
            headStyle={{ background: '#fafafa', borderRadius: '12px 12px 0 0' }}
          >
            <Row gutter={[16, 8]}>
              <Col xs={24} sm={8}>
                <Form.Item label="تاریخ عضویت" name="julianMembershipDate">
                  <PersianDatePickerInline
                    defaultDate={form
                      .getFieldValue("julianMembershipDate")
                      ?.toString()
                      ?.substring(0, 10)}
                    setPersianDate={setSolarMembershipDate}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item label="تاریخ اعتبار بیمه" name="solarInsuranceExpirationDate">
                  <PersianDatePickerInline
                    defaultDate={form
                      .getFieldValue("julianInsuranceExpirationDate")
                      ?.toString()
                      ?.substring(0, 10)}
                    setPersianDate={setSolarInsuranceExpirationDate}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          {/* Action Buttons */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'flex-end', 
            gap: '12px',
            paddingTop: '16px',
            borderTop: '1px solid #f0f0f0'
          }}>
            <Button
              size="large"
              icon={<CloseOutlined />}
              onClick={handleCloseModal}
              style={{ borderRadius: '8px', minWidth: '120px' }}
            >
              انصراف
            </Button>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={modalLoading}
              icon={editingId ? <SaveOutlined /> : <PlusOutlined />}
              style={{
                borderRadius: '8px',
                minWidth: '140px',
                background: editingId 
                  ? 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)'
                  : 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
                border: 'none',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
              }}
            >
              {editingId ? 'ذخیره تغییرات' : 'افزودن مهندس'}
            </Button>
          </div>
        </Form>
      </Modal>

      {/* Table */}
      <Table
        loading={loading}
        size="middle"
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} از ${total} مهندس`,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
        scroll={{
          y: 600,
          x: 800,
        }}
        sticky
        columns={columns({ props, handleEdit })}
        rowKey={record => record.id}
        dataSource={lstEngineer}
        onChange={onChange}
        style={{
          borderRadius: '12px',
          overflow: 'hidden',
        }}
      />
    </>
  )
}

const mapStateToProps = ({ Engineers, USERs }) => ({
  lstEngineer: Engineers.lstEngineer,
  error: Engineers.error,
  success: Engineers.success,
  loading: Engineers.loading,
  lstUserFiles: USERs.lstUserFiles,
  errorUser: USERs.error,
  successUser: USERs.success,
})

const mapDispatchToProps = dispatch => ({
  onGetListEngineer: () => dispatch(getListEngineer()),
  onUpsertEngineer: data => dispatch(upsertEngineer(data)),
  onUpsertEngHistory: data => dispatch(upsertEngHistory(data)),
  onGetUserFiles: searchValue => dispatch(getUserFiles(searchValue)),
  onAddUserFile: attachData => dispatch(addUserFile(attachData)),
  onDeleteUserFile: id => dispatch(deleteUserFile(id)),
  onResetUSERFlag: searchValue => dispatch(resetUSERFlag(searchValue)),
  onFilterEngineer: data => dispatch(filterEngineer(data)),
  onFilterLoading: data => dispatch(filterLoading(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EngineerList))
